<template>
  <div>
    <v-btn @click="disableMFA" v-if="this.mfa">Disable MFA</v-btn>
    <v-btn @click="enableMFA" v-if="!this.mfa">Enable MFA</v-btn>
    <br>
    <img :src="this.qrcode" alt v-if="this.mfa">
    <span v-if="this.mfa">{{ this.secret }}</span>
    <v-btn @click="generateCode" v-if="this.mfa">Generate new code</v-btn>
  </div>
</template>

<script>
import { GoogleAuthenticator } from "../components/2fa/GoogleAuthenticator.js";
export default {
  mixins: [GoogleAuthenticator],
  data() {
    return {
      qrcode: null,
      secret: null,
      GACode: null,
      mfa: null
    };
  },
  mounted() {
    this.mfaEnabled();
    this.doGetSecret();
    this.getQRCode();
  },
  methods: {
    mfaEnabled() {
      this.getMFA()
      .then(result => {
        this.mfa = result;
      });
    },
    disableMFA() {
      this.setMFA(false)
      .then(() => {
        this.mfaEnabled();
      });
    },
    enableMFA() {
      this.setMFA(true)
      .then(() => {
        this.mfaEnabled();
      });
    },
    generateCode() {
      this.generateSecret()
      .then(() => {
        this.doGetQRCode();
        this.doGetSecret();
      });
    },
    doGetQRCode() {
      this.getQRCode()
      .then(result => {
        this.qrcode = result;
      });
    },
    doGetSecret() {
      this.getSecret()
      .then(result => {
        this.secret = result;
      });
    }
  }
};
</script>